import { defineStore } from 'pinia';
import {
  APPLICATION_TYPE_UNREAD_COUNT_FETCHERS,
  getApplicationsUnreadCount,
  getSystemNotificationsUnreadCount,
  getUserSupportUnreadCount,
} from 'app/src/shared/api/sidebar-unread-counts';
import { SIDEBAR_MENU_IDS } from 'app/src/shared/sidebar-unread-badges/menu-ids';

export const useSidebarUnreadBadgesStore = defineStore('sidebar-unread-badges', {
  state: () => ({
    badges: {} as Record<string, number>,
    dotMenuIds: [] as string[],
    hasSystemNotificationsUnread: false,
    /** Счётчик для реактивного пересчёта меню. */
    stamp: 0,
    refreshInFlight: null as Promise<void> | null,
  }),

  actions: {
    clear() {
      this.badges = {};
      this.dotMenuIds = [];
      this.hasSystemNotificationsUnread = false;
      this.stamp += 1;
    },

    async refresh() {
      if (this.refreshInFlight) {
        return this.refreshInFlight;
      }

      this.refreshInFlight = this.runRefresh().finally(() => {
        this.refreshInFlight = null;
      });

      return this.refreshInFlight;
    },

    async runRefresh() {
      const badges: Record<string, number> = {};
      let dotMenuIds: string[] = [];
      let hasSystemNotificationsUnread = false;

      try {
        const applicationTypeFetchers = Object.entries(APPLICATION_TYPE_UNREAD_COUNT_FETCHERS);

        const [
          applicationsTotal,
          technicalSupportTotal,
          systemNotificationsTotal,
          ...applicationTypeCounts
        ] = await Promise.all([
          getApplicationsUnreadCount().catch(() => 0),
          getUserSupportUnreadCount().catch(() => 0),
          getSystemNotificationsUnreadCount().catch(() => 0),
          ...applicationTypeFetchers.map(([ , fetchCount ]) => fetchCount().catch(() => 0)),
        ]);

        hasSystemNotificationsUnread = systemNotificationsTotal > 0;

        if (technicalSupportTotal > 0) {
          badges[ SIDEBAR_MENU_IDS.TECHNICAL_SUPPORT ] = technicalSupportTotal;
        }

        let applicationsUnreadFromTypes = 0;
        applicationTypeFetchers.forEach(([ menuId ], index) => {
          const count = applicationTypeCounts[ index ] ?? 0;
          if (count > 0) {
            badges[ menuId ] = count;
            applicationsUnreadFromTypes += count;
          }
        });

        if (applicationsUnreadFromTypes > 0 || applicationsTotal > 0) {
          dotMenuIds = [ SIDEBAR_MENU_IDS.APPLICATIONS ];
        }
      } catch {
        /* не ломаем меню при ошибке счётчиков */
      }

      this.badges = badges;
      this.dotMenuIds = dotMenuIds;
      this.hasSystemNotificationsUnread = hasSystemNotificationsUnread;
      this.stamp += 1;
    },
  },
});
